import React from 'react';

import './topbanner.css';

const TopBanner = ({ banner_top }) => (
  <div className='topbanner'>
    <a href={banner_top.url}>
      <img
        src={`${process.env.REACT_APP_IMG_SERVER}${banner_top.image}`}
        //className='topbanner--desktop'
        alt={banner_top.title}
      />
      {/* <img
          src={'${process.env.REACT_APP_IMG_SERVER}/img/7992/large'}
        className='topbanner--mobile'
        alt={banner_top.title}
      /> */}
    </a>
  </div>
);

export default TopBanner;



// WEBPACK FOOTER //
// ./src/components/TopBanner/index.js